import { render, staticRenderFns } from "./BusinessConsultationCreate.vue?vue&type=template&id=485c3244&"
import script from "./BusinessConsultationCreate.vue?vue&type=script&lang=js&"
export * from "./BusinessConsultationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports